import './climate-calculator.scss';
import { createElementFromHTML, smoothScrollTo, getOffset } from '../../utilities/js/helper';
import AjaxLoad from '../../utilities/js/ajax-load';

class ClimateCalculator {
    constructor (element) {
        this.$climateCalculator = element;
        this.$result = this.$climateCalculator.querySelector('[data-climate-calculator="result"]');
        this.$calculator = this.$climateCalculator.querySelector('[data-climate-calculator="calculator"]');
        this.$form = this.$climateCalculator.querySelector('form');
        this.$formTarget = this.$climateCalculator.querySelector('[data-climate-calculator-form-target]');
        this.$$selects = this.$form.querySelectorAll('select');
        this.$input = this.$form.querySelector('input');
        this.$submitButton = this.$form.querySelector('[data-climate-calculator="submit"]');
        this.$renewButton = this.$result.querySelector('[data-climate-calculator="renew"]');
        this.ajaxActive = false;
    }

    initialize () {
        this.setEvents();
    }

    setCalculation (data) {
        this.$result.querySelector('[data-climate-calculator="tripcode"]').innerHTML = this.$form.querySelector('[name="climate_cost_calculator[tripCode]"]').value;
        this.$result.querySelector('[data-climate-calculator="cabintype"]').innerHTML = this.$form.querySelector('[name="climate_cost_calculator[cabinType]"]').value;
        this.$result.querySelector('[data-climate-calculator="occupancy"]').innerHTML = this.$form.querySelector('[name="climate_cost_calculator[guestCount]"]').value;
        this.$result.querySelector('[data-climate-calculator="compensating"]').innerHTML = this.$form.querySelector('[name="climate_cost_calculator[allocation]"]').value;
        this.$result.querySelector('[data-climate-calculator="kg"]').innerHTML = data.kg;
        this.$result.querySelector('[data-climate-calculator="eur"]').innerHTML = data.price_in_eur + '€ (' + totalNotice + ' = ' + data.hlc_part + '€)'; // eslint-disable-line
        this.$result.querySelector('[data-climate-calculator="days"]').innerHTML = data.input_params.cruise_duration;
        this.$result.classList.remove('is--hidden');
        this.$calculator.classList.add('is--hidden');
    }

    setEvents () {
        this.$form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.$submitButton.appendChild(createElementFromHTML(window.OPTIONS.loader));

            this.sendRequest();
        });

        this.$renewButton.addEventListener('click', () => {
            this.$result.classList.add('is--hidden');
            this.$calculator.classList.remove('is--hidden');

            const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--main-height'));

            setTimeout(() => {
                smoothScrollTo(0, getOffset(this.$form).top - headerHeight - 24, 400);
            }, 250);
        });
    }

    checkCompleteness () {
        this.$$selects.forEach(($select) => {
            $select.closest('.form__select').classList.remove('has--error');
        });

        this.$input.closest('.form__input').classList.remove('has--error');
    }

    sendRequest () {
        if (this.ajaxActive === false) {
            this.ajaxActive = true;

            this.result = new AjaxLoad(this.$form.getAttribute('action'), {
                requestMethod: 'POST',
                requestData: new FormData(this.$form),
                onSuccess: (resultText) => {
                    this.$submitButton.querySelector('.loading')?.remove();
                    const results = JSON.parse(resultText);
                    this.setResult(results);
                },
                onError: (error) => {
                    console.warn(error);
                }
            });
        }
    }

    setResult (results) {
        this.ajaxActive = false;

        if (results.success) {
            this.checkCompleteness();

            this.setCalculation(results.data);
        } else {
            const $result = createElementFromHTML(results.html);
            this.$formTarget.innerHTML = '';

            this.$formTarget.appendChild($result);

            const contentUpdateEvent = new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: this.$climateCalculator
                }
            });

            window.dispatchEvent(contentUpdateEvent);
            const $$climateCalculator = new ClimateCalculator(this.$climateCalculator);
            $$climateCalculator.initialize();
        }
    }
}

export { ClimateCalculator };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $climateCalculator = $context.querySelectorAll('[data-climate-calculator="root"]');

        for (let i = 0; i < $climateCalculator.length; i++) {
            const $$climateCalculator = new ClimateCalculator($climateCalculator[i]);
            $$climateCalculator.initialize();
        }
    }
});
